"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _store = _interopRequireDefault(require("store/dist/store.modern"));
// import engine from 'store/src/store-engine'
// import cookieStore from 'store/storages/cookieStorage'
// const storages = [cookieStore]
// const plugins = []
// const store = engine.createStore(storages, plugins)
var STORE_KEY = '__NOBIA__';
var localStore = {
  get: function get() {
    return _store.default.get(STORE_KEY);
  },
  set: function set(value) {
    _store.default.set(STORE_KEY, value);
  },
  clear: function clear() {
    _store.default.remove(STORE_KEY);
  }
};
var _default = exports.default = localStore;